import { render, staticRenderFns } from "./companyPriceListTable.vue?vue&type=template&id=383328ee&"
import script from "./companyPriceListTable.vue?vue&type=script&lang=ts&"
export * from "./companyPriceListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports